import { render, staticRenderFns } from "./FinancesInvoicesCompanyPeriodsTable.vue?vue&type=template&id=06b76774&scoped=true"
import script from "./FinancesInvoicesCompanyPeriodsTable.vue?vue&type=script&lang=js"
export * from "./FinancesInvoicesCompanyPeriodsTable.vue?vue&type=script&lang=js"
import style0 from "./FinancesInvoicesCompanyPeriodsTable.vue?vue&type=style&index=0&id=06b76774&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b76774",
  null
  
)

export default component.exports